// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:11:16

export default {
  "id": "royal-puzzle-burst",
  "slug": "royal-puzzle-burst",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/eb135a49516447b7a7cc0a875008fd7f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/eb135a49516447b7a7cc0a875008fd7f/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Royal puzzle Burst",
      "description": "Tap blocks of the same color to make them burst and eliminate attacking blobs! Enjoy a straightforward and gratifying game with intuitive controls.",
      "instructions": "click on blocks of the same color",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "clicker",
        "dash",
        "defence",
        "sliding-puzzle"
      ]
    },
    "zh-CN": {
      "title": "皇家拼图爆发",
      "description": "点击相同颜色的方块使其爆裂并消灭攻击的球体！享受一款简单直接、令人满足的游戏，拥有直观的操控方式。",
      "instructions": "点击相同颜色的方块",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "点击器",
        "冲刺",
        "防御",
        "滑动拼图"
      ]
    },
    "zh-TW": {
      "title": "皇家拼圖爆發",
      "description": "點擊相同顏色的方塊使其爆裂並消除攻擊的粘液！享受一個簡單而滿足人的遊戲，並具有直觀的操作。",
      "instructions": "點擊同色塊",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "點擊器",
        "衝刺",
        "防禦",
        "滑動拼圖"
      ]
    },
    "zh-HK": {
      "title": "皇家拼圖爆裂",
      "description": "按壓同色塊使其爆裂並消除攻擊的黏液！享受簡單而滿足的遊戲，並具直觀的操作方式。",
      "instructions": "點擊相同顏色的方塊",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "點擊器",
        "衝刺",
        "防禦",
        "滑動拼圖"
      ]
    },
    "ja": {
      "title": "ロイヤルパズルバースト",
      "description": "同じ色のブロックをタップして爆破し、攻撃するボブを排除しましょう！直感的な操作で楽しむシンプルで満足度の高いゲームです。",
      "instructions": "同じ色のブロックをクリックしてください",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "クリッカー",
        "ダッシュ",
        "ディフェンス",
        "スライディングパズル"
      ]
    },
    "ko": {
      "title": "로얄 퍼즐 버스트",
      "description": "같은 색의 블록을 탭하여 터빈하고 공격 블로브를 제거하세요! 직관적인 조종으로 즐겁고 만족스러운 게임을 즐겨보세요!",
      "instructions": "동일한 색의 블록을 클릭하세요",
      "genres": [
        "캐주얼",
        "پازل"
      ],
      "tags": [
        "클릭러",
        "dash",
        "방어",
        "슬라이딩 퍼즐"
      ]
    },
    "fr": {
      "title": "Boum de puzzle royal",
      "description": "Appuie sur les blocs de la même couleur pour les faire exploser et éliminer les blobs agressifs ! Profite d'un jeu simple et satisfaisant avec une manipulation intuitive.",
      "instructions": "Cliquez sur les blocs de la même couleur",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "cliqueur",
        "dash",
        "défense",
        "puzzle glissant"
      ]
    }
  }
};
